export const AgileFallback = (e) =>{
    e.target.src = '/images/Fallback.png';
}

// export const API_URL = "http://localhost/safpro_backend";


export const API_URL = "https://safprotech.com/safpro-backend";
